import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { CheckboxCheckmarkIcon } from '@iris/react-icons/CheckboxCheckmarkIcon';
import { CheckboxDashIcon } from '@iris/react-icons/CheckboxDashIcon';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import baseCheckboxStyles from './BaseCheckbox.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const BaseCheckbox = forwardRef((_a, ref) => {
    var { className = "", disabled = false, inverse = false, error = false, checked, onCheckedChange, indeterminate } = _a, otherProps = __rest(_a, ["className", "disabled", "inverse", "error", "checked", "onCheckedChange", "indeterminate"]);
    //  TODO: handle indeterminate state
    const classes = baseCheckboxStyles({
        inverse,
        error,
        disabled,
    });
    return (jsx(RadixCheckbox.Root, Object.assign({ ref: ref, checked: checked, onCheckedChange: onCheckedChange, disabled: disabled, className: cn(classes.base(), className) }, otherProps, { children: jsx(RadixCheckbox.Indicator, { className: classes.indicator(), children: indeterminate ? jsx(CheckboxDashIcon, {}) : jsx(CheckboxCheckmarkIcon, {}) }) })));
});
BaseCheckbox.displayName = "BaseCheckbox";

export { BaseCheckbox };
